import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTheme } from 'common/styling/theme';
import { MenuIcon, GridIcon } from 'common/icons';
import { staticStyles, getDynamicStyles } from './style';

const SwitchTableVariantButtons = ({ tableVariant, handleSelectNewVariant, handleSelectLegacyVariant, theme }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  return (
    <div className="SwitchTableVariant__buttons-wrapper">
      <button
        type="button"
        className={classNames('SwitchTableVariant__button', {
          'SwitchTableVariant__button--active': tableVariant === 'legacy',
        })}
        onClick={handleSelectLegacyVariant}>
        <MenuIcon />
      </button>
      <button
        type="button"
        className={classNames('SwitchTableVariant__button', {
          'SwitchTableVariant__button--active': tableVariant === 'new',
        })}
        onClick={handleSelectNewVariant}>
        <GridIcon />
      </button>
      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

SwitchTableVariantButtons.propTypes = {
  tableVariant: PropTypes.string.isRequired,
  handleSelectNewVariant: PropTypes.func.isRequired,
  handleSelectLegacyVariant: PropTypes.func.isRequired,
  theme: PropTypes.object,
};

SwitchTableVariantButtons.defaultProps = {
  theme: {},
};

export default withTheme()(SwitchTableVariantButtons);
